import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAgent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	className: "app-icon app-icon--small",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		d: "M23.922 23.085h2.638a1.203 1.203 0 110 2.406h-2.638v2.638a1.203 1.203 0 11-2.406 0v-2.638h-2.638a1.203 1.203 0 110-2.406h2.638v-2.638a1.203 1.203 0 112.406 0v2.638zm-8.209-5.961c-3.822 0-6.92-3.117-6.92-6.962S11.891 3.2 15.713 3.2s6.92 3.117 6.92 6.962-3.098 6.962-6.92 6.962zm0-2.421c2.492 0 4.513-2.033 4.513-4.541s-2.02-4.541-4.513-4.541c-2.492 0-4.513 2.033-4.513 4.541s2.02 4.541 4.513 4.541zm-9.04 12.612c0 .669-.539 1.211-1.203 1.211s-1.203-.542-1.203-1.211c0-4.589 3.924-8.274 8.725-8.274h5.014c.665 0 1.203.542 1.203 1.211s-.539 1.211-1.203 1.211h-5.014c-3.507 0-6.318 2.64-6.318 5.852z"
	})
});
export default SvgAgent;
